export default class Address {
  constructor (address = {}, isMultipleLocations = false) {
    this.addressNumber = isMultipleLocations ? '' : (address.addressNumber || '')
    this.addressStreet = isMultipleLocations ? '' : (address.addressStreet || '')
    this.address1 = isMultipleLocations ? 'Multiple locations' : (address.address1 || `${address.addressNumber || ''} ${address.addressStreet || ''}`.trim())
    this.address2 = isMultipleLocations ? '' : (address.address2 || '')
    this.city = isMultipleLocations ? '' : (address.city || '')
    this.state = isMultipleLocations ? '' : (address.state || '')
    this.zip = isMultipleLocations ? '' : (address.zip || '')
  }
}
